/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Witty_Such_Halibut_JoltInputs */

const fr_witty_such_halibut_jolt = /** @type {(inputs: Witty_Such_Halibut_JoltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut`)
};

/**

* @param {Witty_Such_Halibut_JoltInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const witty_such_halibut_jolt = /** @type {((inputs?: Witty_Such_Halibut_JoltInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Witty_Such_Halibut_JoltInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_witty_such_halibut_jolt(inputs)
});